import React from 'react';
import './Footer.css';
import {FaGithub} from "react-icons/fa";

const footer = (props) => {

    return (
        <footer>
            Designed & Developed By&nbsp;<a href={'https://sunnysetia.in'}>Sunny Setia</a>&nbsp;
            <a href="https://github.com/sunnysetia93">
                <FaGithub className="github" />
            </a>
        </footer>
    );

}

export default footer;